import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { EmailAuthenticationService } from '@shared/services';
import { MicrosoftService } from '../../services/microsoft.service';
import { ENVIRONMENT, Environment } from '@shared/environment';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

@Injectable({
	providedIn: 'root',
})
export class AuthGoogleService {
	private readonly document = inject(DOCUMENT);
	private readonly environment = inject<Environment>(ENVIRONMENT);

	company_name = this.environment.company;
	private GOOGLE_PERMISSION_AUTH_API: string = '/api/googleapis/glogin';

	constructor(
		private http: HttpClient,
		public dialog: MatDialog,
		private authenService: EmailAuthenticationService,
		private emailService: EmailAuthenticationService,
		private snackBar: MatSnackBar,
		private microsoftService: MicrosoftService
	) {}

	getGooglePermisson() {
		return this.http.get(this.GOOGLE_PERMISSION_AUTH_API);
	}

	openDialog(): MatDialogRef<ConfirmationDialog, any> {
		return this.dialog.open(ConfirmationDialog, {
			width: '250px',
			data: {
				title: 'Google',
				body: `Allow ${this.company_name} to access your email`,
				btnConfirm: 'Allow',
			},
		});
	}

	// TODO: [Feature Restoration] Full OAuth refactor needed when Email feature is restored.
	// The intended pattern is Browser.open() + App URL Listener deep link to handle the OAuth callback.
	// Currently guarded for MVP — Email/Mail is hidden via Feature Visibility so this flow is unreachable.
	//
	// Intended refactor direction:
	// 1. Use Browser.open({ url }) to open the OAuth consent page in the system browser
	// 2. Register a custom URL scheme (ru-app://) in capacitor.config.ts
	// 3. Listen for App.addListener('appUrlOpen', ...) to capture the OAuth redirect
	// 4. Parse the redirect URL and complete the auth flow in-app
	// 5. Call Browser.close() if needed (only works on iOS)
	async openLinkInBrowser(
		url: string,
		handler: (mess: string) => void
	): Promise<void> {
		this.authenService.saveLastUsingPath();
		this.authenService.setAuthenGmailFlag();

		if (Capacitor.isNativePlatform()) {
			await Browser.open({ url });
			// Browser.open() opens the system browser — we cannot detect when the user
			// returns to the app via loadstop/loadstart like InAppBrowser could.
			// The app resume handler in landing-mobile-page.component.ts will trigger
			// handleAuthenGmailIfNeeded() when the user switches back to the app.
		} else {
			this.document.defaultView!.open(
				url,
				'_self',
				'width=600,height=600'
			);
		}
	}

	private GOOGLE_ALREADY_LOGGED = 'You already logged in google apis.';
	authenEmail() {
		var server = localStorage.getItem('mailServer');
		if (server === 'google') {
			this.getGooglePermisson().subscribe(
				rs => {
					if (rs !== this.GOOGLE_ALREADY_LOGGED) {
						let url = rs.toString();
						this.openLinkInBrowser(url, mess => {
							if (mess.toLowerCase() == 'closed') {
								setTimeout(() => {
									this.emailService.shouldRefreshEmailProfile(
										true
									);
								}, 3000);
							}
						});
					} else {
						alert(this.GOOGLE_ALREADY_LOGGED);
					}
				},
				err => {
					this.snackBar.open(err.error['Message']);
				}
			);
		} else {
			this.microsoftService.getMicrosoftPermisson().subscribe(rs => {
				let url = rs.toString();
				this.openLinkInBrowser(url, mess => {
					if (mess.toLowerCase() == 'closed') {
						setTimeout(() => {
							this.emailService.shouldRefreshEmailProfile(true);
						}, 3000);
					}
				});
			});
		}
	}
}
